<template>
  <div>
    <app-header title="Store Credits" />
    <b-container>
      <b-row>
        <b-col md="8">
          <b-form-group>
            <b-input-group class="mb-3">
              <search-input v-model="query" />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        id="store-table"
        :per-page="perPage"
        :current-page="currentPage"
        :items="displayStores"
        :fields="fields"
        :busy="loading"
        show-empty
        striped
        hover
        responsive
      >
        <template v-slot:cell(name)="data">
          <a target="_blank" :href="'http://dashboard.gokaizen.com/#/stores/' + data.item.id">
            {{ data.item.name }}
          </a>
        </template>
        <template v-slot:cell(action)="data">
          <button class="btn btn-sm btn-primary" @click="grantCredits(data.item)">
            Grant Credits
          </button>
        </template>
        <template v-slot:table-busy>
          <loading-spinner />
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="displayStores && displayStores.length"
        :per-page="perPage"
        align="right"
        aria-controls="subdistributor-table"
      />
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import AppHeader from '@/components/AppHeader';
import SearchInput from '@/components/SearchInput';
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  components: {
    AppHeader,
    SearchInput,
    LoadingSpinner,
  },

  data() {
    return {
      query: null,
      stores: null,
      fields: [
        { key: 'id', label: 'Store ID', sortable: true },
        { key: 'name', label: 'Name' },
        { key: 'chain_name', label: 'Chain name' },
        { key: 'country', label: 'Country' },
        { key: 'credits_available', label: 'Credits Available' },
        { key: 'action', label: '' },
      ],
      currentPage: 1,
      perPage: 10,
      loading: false,
    };
  },

  computed: {
    totalRows() {
      return this.stores && this.stores.length;
    },

    displayStores() {
      return $search(this.stores, this.query, ['name', 'chain_name', 'country']);
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    refreshData() {
      this.loading = true;
      $api.get('/v1/internal/stores').then((stores) => {
        this.stores = stores;
        this.loading = false;
      }).catch(() => { this.loading = false; });
    },

    grantCredits(store) {
      const count = prompt('How many credits?') * 1; // eslint-disable-line no-alert
      const posNegSign = count < 0 ? '' : '+';
      // eslint-disable-next-line no-restricted-globals
      if (confirm(`Are you sure you wish to grant ${posNegSign}${count} credits to ${store.name}?`)) { // eslint-disable-line no-alert
        store.credits_available += count;
        $api.put(`/v1/internal/stores/${store.id}`, store);
      }
    },
  },
};
</script>
